import HorizontalLinearStepper from "@/views/elements/HorizontalLinearStepper"
import WrapperModal, { PropsTypeWrapperModal } from "@/views/elements/WrapperModal"
import { useState } from "react"
import Step1 from "./Step1"
import Step2 from "./Step2"
// import Step3 from "./Step3"

import { produce } from "immer"
import { useTranslation } from "react-i18next"
import { VerifyData, InitVerifyData, doInit2factorAuth } from "@/controllers/gridManager/accountsManager/accountManager"
import { setStateLoadingAction } from "@/stores/dataManager/Actions/appAction"

export type DataOnParents = {
    Step1: {
    },
    Step2: {
    },
    Step3: {
    },
    dataVerify: VerifyData
}

export type KeyDataParents = keyof DataOnParents

export default function SellOddLotStocks({ open, title, handleClose, data }: PropsTypeWrapperModal) {
    const { t } = useTranslation()
    const steps = [t("copytrade.common.info"), t("copytrade.common.confirm"), t("copytrade.common.complete")]

    const { dataMasterTrade } = data

    // console.log('ha_check_dataMasterTrade', data)

    const [activeStep, setActiveStep] = useState<number>(0)
    const [dataOnParents, setDataOnParents] = useState<DataOnParents>({
        Step1: {

        },
        Step2: {

        },
        Step3: {

        },
        dataVerify: {
            ...InitVerifyData
        }
    })

    const handleSaveDataOnParents = (key: KeyDataParents, data: {}) => {
        // console.log('ha_check_handleSaveDataOnParents', { key, data });
        setDataOnParents(
            produce((draft) => {
                if (key === "dataVerify") {
                    draft['dataVerify'] = data as VerifyData
                } else {
                    draft[key] = data
                }
            })
        );
    }

    const handleBackStep = () => {
        if (activeStep !== 0) {
            setActiveStep(prevStep => prevStep - 1)
        }
    }

    const handleNextStep = async () => {
        const currentStep = activeStep + 1
        if (currentStep === 1) {
            setStateLoadingAction(true)
            const { isSuccess, data } = await doInit2factorAuth()
            setStateLoadingAction(false)
            if (isSuccess && Object.hasOwn(data, 'transactionId')) {
                handleSaveDataOnParents("dataVerify", data);
            }
        }

        setActiveStep(prevStep => prevStep + 1)
    }

    const currentStep = activeStep + 1

    const dynamicWidth = currentStep === 1 ? 850 : 500
    return (
        <WrapperModal
            open={open}
            handleClose={handleClose}
            title={t("copytrade.sellOddLot.title")}
            width={dynamicWidth}
        >
            <HorizontalLinearStepper
                steps={steps}
                activeStep={activeStep}
                setActiveStep={setActiveStep}
            />

            {
                currentStep === 1 && <Step1
                    close={handleClose}
                    back={handleBackStep}
                    next={handleNextStep}
                    handleSaveDataOnParents={handleSaveDataOnParents}
                    dataOnParents={dataOnParents}
                    masterAccount={dataMasterTrade?.mtacctno ?? ''}
                />
            }

            {
                currentStep === 2 && <Step2
                    close={handleClose}
                    back={handleBackStep}
                    next={handleNextStep}
                    handleSaveDataOnParents={handleSaveDataOnParents}
                    dataOnParents={dataOnParents}
                    masterAccount={dataMasterTrade?.mtacctno ?? ''}
                />
            }

            {/* {
                currentStep === 3 && <Step3
                    close={handleClose}
                />
            } */}

        </WrapperModal>
    )
}